<template>
    <div :class="'app-activation-wrapper ' + showActivationView">
      <b-row class="form-stepper">
        <b-col class="info-step" cols="3"
               @click="goToStepBefore(beforeStepperTariff, infoStepName)"
               v-bind:class="{ active: showStep(infoStepName), 'before-active': beforeStepperTariff }">
          <slot name="lblInfoStep"><span>1. </span>sim-karte freischalten</slot>
        </b-col>
        <b-col class="tariff-step" cols="3"
               @click="goToStepBefore(beforeStepperPersonalDataTopUp, tariffStepName)"
               v-bind:class="{ active: showStep(tariffStepName), 'before-active': beforeStepperPersonalDataTopUp }">
          <slot name="lblTariffStep"><span>2. </span>Tarifauswahl</slot>
        </b-col>
        <b-col class="personal-data-step" cols="3"
               @click="goToStepBefore(beforeStepperSummary, personalDataInputStepName)"
               v-bind:class="{ active: showStep(personalDataInputStepName) || showStep(topUpStepName), 'before-active': beforeStepperSummary }">
          <slot name="lblPersonalDataStep"><span>3. </span>Deine Kundendaten</slot>
        </b-col>
        <b-col class="summary-step" cols="3" v-bind:class="{ active: showStep(summaryStepName) }">
          <slot name="lblSummaryStep"><span>4. </span>sim-karte aktivieren</slot>
        </b-col>
      </b-row>
      <ActivationInfo v-if="showStep(infoStepName)"
                        :activation-code-min="activationCodeMin"
                        :activation-code-max="activationCodeMax"
                        :next-step="tariffStepName"
        >
          <template v-for="slot in possibleChildSlotsFor('Info')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationInfo>
      <ActivationTariff v-if="showStep(tariffStepName)"
                        :previous-step="infoStepName"
                        :next-step="personalDataInputStepName"
                        :extra="extraData.extraData"
      >
        <template v-for="slot in possibleChildSlotsFor('Tariff')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationTariff>
      <ActivationTariffInfoBox :tariff="selectedTariff"
        v-if="showStep(personalDataInputStepName) || showStep(topUpStepName) || showStep(summaryStepName)"
      >
        <template v-for="slot in possibleChildSlotsFor('TariffInfoBox')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationTariffInfoBox>
      <ActivationPersonalData v-if="showStep(personalDataInputStepName)"
                                    :alowed-min-age="16"
                                    :previous-step="tariffStepName"
                                    :next-step="topUpStepName"
                                    :show-esim="showEsim"
      >
        <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationPersonalData>
      <ActivationTopUpAndPayment v-if="showStep(topUpStepName)"
                        :credit-card-frame-address="creditCardFrameAddress"
                        :credit-card-redirect-url="creditCardRedirectUrl"
                        :previous-step="personalDataInputStepName"
                        :next-step="summaryStepName"
                        :monthly-value="topUpMonthlyValue"
                        :selected-tariff="selectedTariff"
      >
        <template v-for="slot in possibleChildSlotsFor('TopUp')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationTopUpAndPayment>
      <ActivationSummary v-if="showStep(summaryStepName)"
                          :previous-step="topUpStepName"
                          next-step="success"
      >
        <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationSummary>
      <ActivationSuccess v-if="showStep(successStepName)">
        <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationSuccess>
      <ActivationInfoModal :next-step="tariffStepName">
        <template v-for="slot in possibleChildSlotsFor('InfoModal')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationInfoModal>
    </div>
</template>

<script>
import ActivationInfo, { stepName as infoStepName } from '@/components/process/LIDL/Activation/Info/ActivationInfo.vue'
import ActivationTariff, { stepName as tariffStepName } from '@/components/process/LIDL/Activation/Tariff/Tariff.vue'
import ActivationPersonalData, { stepName as personalDataInputStepName } from '@/components/process/LIDL/Activation/PersonalData/EnterPersonalData.vue'
import ActivationSummary, { stepName as summaryStepName } from '@/components/process/LIDL/Activation/Summary/ActivationSummary.vue'
import { mapGetters, mapMutations } from 'vuex'
import ActivationTopUpAndPayment, { stepName as topUpStepName } from '@/components/process/LIDL/Activation/TopUp/EnterTopUpAndPayment.vue'
import ActivationSuccess, { stepName as successStepName } from '@/components/process/LIDL/Activation/Success/ActivationSuccess.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import extraData from '@/mixins/extraData'
import processWrapper from '@/mixins/processWrapper'
import ActivationTariffInfoBox from '../Tariff/ShowTariffInfoBox.vue'
import ActivationInfoModal from '../Info/ActivationInfoModal.vue'

export default {
  name: 'ActivationWrapper',
  import: {
    infoStepName,
    tariffStepName,
    personalDataInputStepName,
    topUpStepName,
    summaryStepName,
    successStepName
  },
  data () {
    return {
      topUpMonthlyValue: [2]
    }
  },
  mixins: [
    transaction('activation'),
    slotProxy(),
    extraData(),
    processWrapper('showActivationView')
  ],
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    },
    otherBrandUrl: {
      type: String
    },
    activationCodeMin: {
      type: Number
    },
    activationCodeMax: {
      type: Number
    },
    showEsim: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToStepBefore (active, step) {
      if (active) {
        this.goToStep(step)
      }
    },
    ...mapMutations('activation', [
      'setBrandUrl',
      'goToStep'
    ])
  },
  computed: {
    beforeStepperTariff: function () {
      return this.beforeStepperPersonalDataTopUp || this.showStep(tariffStepName)
    },
    beforeStepperPersonalDataTopUp: function () {
      return this.beforeStepperSummary || this.showStep(personalDataInputStepName) || this.showStep(topUpStepName)
    },
    beforeStepperSummary: function () {
      return this.showStep(summaryStepName)
    },
    selectedTariff: function () {
      return this.savedTariff || {}
    },
    ...mapGetters('activation', [
      'showActivationView'
    ]),
    ...mapGetters('activation/tariff', [
      'savedTariff'
    ])
  },
  components: {
    ActivationInfoModal,
    ActivationTariffInfoBox,
    ActivationTariff,
    ActivationTopUpAndPayment,
    ActivationSuccess,
    ActivationPersonalData,
    ActivationInfo,
    ActivationSummary
  }
}
</script>
